import styled from 'styled-components';

export const DropdownLegend = styled.div`
  font-size: 11px;
  margin-top: 10px;
  display: inline-block;

  p {
    font-size: inherit;
    margin-top: inherit;
    padding: 0;
    line-height: 1;
  }
`;
